/* eslint-disable no-extra-boolean-cast */

import {catchError, timeout, map,  mergeMap, debounceTime, withLatestFrom, exhaustMap, share } from 'rxjs/operators';
import { AppState } from './../../interfaces/app-state.interface';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable ,  of, from  } from 'rxjs';
import { BanksService } from '../../services/banks/banks.service';
import { BanksAction } from './banks.action';
import { ErrorsType } from '../../enum/errors.type';
import { Store } from '@ngrx/store';
import { TextUtils } from '../../resources/text.utils';
import { BackendService } from '../../services/backend/backend.service';

@Injectable()
export class BanksEffects {

    public banks$ = this.store.select((store) => store.banks.data);

    interationSuccess$ = createEffect(() => this.actions$
        .pipe(ofType(BanksAction.createItemSuccess, BanksAction.updateItemSuccess, BanksAction.deleteItemSuccess),
         share()), { dispatch: false });

    interationError$ = createEffect(() => this.actions$
        .pipe(ofType(BanksAction.createItemError, BanksAction.updateItemError, BanksAction.deleteItemError),
        share()), { dispatch: false });

    createBank$ = createEffect(() => this.actions$
        .pipe(
            ofType(BanksAction.createItem),
            mergeMap((action: any) => {
                return this.banksService.create(action.payload).pipe(
                    mergeMap((result) => {
                        if (result.ok) {
                            return from([
                                { type: BanksAction.createItemSuccess, payload: result.value },
                                { type: BanksAction.getItems }
                            ]);
                        }
                        return from([
                            { type: BanksAction.createItemError, payload: { type: ErrorsType.Error, error: result } },
                            { type: BanksAction.getItems } 
                        ]);
                    }),
                    catchError((error) => {
                        if (error.status === 504 || error.status === 0) {
                            console.warn("Gateway Timeout detectado (29s). Forçando atualização da lista.");
                            return from([
                                { type: BanksAction.createItemSuccess, payload: null },
                                { type: BanksAction.getItems }
                            ]);
                        }
                        return of({ type: BanksAction.createItemError, payload: { type: ErrorsType.Error, error } });
                    })
                );
            }),
            share()
        ));

    updateBank$ = createEffect(() => this.actions$
        .pipe(
            ofType(BanksAction.updateItem),
            mergeMap((action: any) => {
                return this.banksService.update(action.payload.value).pipe(
                    map((result) => {
                        if (result.ok) {
                            return { type: BanksAction.updateItemSuccess, payload: result.value };
                        }
                        if ( result.hasWarning ) {
                            return { type: BanksAction.updateItemError, payload: { type: ErrorsType.Warning, value: result.messages } };
                        }
                        return { type: BanksAction.updateItemError, payload: { type: ErrorsType.Error, error: result } };
                    }),
                    catchError((e) => {
                        return of({ type: BanksAction.updateItemError, payload: { type: ErrorsType.Error, error: e } });
                    })
                );
            }),
            share()
        ));

    deleteBank$ = createEffect(() => this.actions$
        .pipe(
            ofType(BanksAction.deleteItem),
            debounceTime(300),
            mergeMap((action: any) => {
                return this.banksService.delete(action.payload).pipe(
                    mergeMap((result) => {
                        if (result.ok) {
                            return from([
                                { type: BanksAction.deleteItemSuccess, payload: action.payload.id }, 
                                { type: BanksAction.getItems }
                            ]);
                        }
                        
                        if (result.hasWarning) {
                            return of({ 
                                type: BanksAction.deleteItemError, 
                                payload: { type: ErrorsType.Warning, value: result.messages } 
                            });
                        }

                        return of({ 
                            type: BanksAction.deleteItemError, 
                            payload: { type: ErrorsType.Error, error: result } 
                        });
                    }),
                    catchError((error) => {
                        if (error.status === 504 || error.status === 0) {
                            console.warn("Timeout no Delete (29s). Assumindo exclusão e atualizando lista.");
                            return from([
                                { type: BanksAction.deleteItemSuccess, payload: action.payload.id },
                                { type: BanksAction.getItems }
                            ]);
                        }
                        return of({ type: BanksAction.deleteItemError, payload: { type: ErrorsType.Error, error } });
                    })
                );
            }),
            share()
    ));

    getBanks$ = createEffect(() => this.actions$
        .pipe(
            ofType(BanksAction.getItems),
            withLatestFrom(this.store.select((state) => state), (action, state) => {
                return { action, storeData: state.banks.data };
            }),
            exhaustMap(({action, storeData}) => {
                if (!!storeData.length) {
                    return of({ type: BanksAction.getItemsSuccess, payload: storeData });
                }
                return this.banksService.getBanksList().pipe(
                    map((result) => {
                        if (result.ok) {
                            const newReturn = result.value.map((value) => {
                                // value.name = this.textUtils.captalizeEveryWord(value.name);
                                return value;
                            });
                            return { type: BanksAction.getItemsSuccess, payload: newReturn };
                        }
                        return { type: BanksAction.getItemsError, payload: { type: ErrorsType.Error, error: result } };
                    }),
                    catchError((e) => {
                        return of({ type: BanksAction.getItemsError, payload: { type: ErrorsType.Error, error: e } });
                    })
                );
            }),
            share()
        ));

    constructor(
        private actions$: Actions,
        private banksService: BanksService,
        private store: Store<AppState>,
        private textUtils: TextUtils,
        private backendService: BackendService,
    ) { }
}
